module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Vetorização:")]), _c('div', [_c('draw-button', {
    staticClass: "col-md-12",
    attrs: {
      "drawTool": _vm.drawTool,
      "name": "drawButton",
      "setDetails": true
    },
    on: {
      "drawComplete": _vm.onGeometriaVetorizada
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erro),
      expression: "erro"
    }],
    staticClass: "invalid-field"
  }, [_vm._v(_vm._s(_vm.erro))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2420906f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inspecao/InspecaoGeometria.vue
// module id = 473
// module chunks = 1